<template>
  <div
    class="am_status_modal pb-4">
    <table
      v-if="mq.current !== 'mobile'"
      class="am_status_modal--table">
      <caption></caption>
      <thead>
        <tr>
          <th>
            <AmTypography
              class="am_status_modal--title"
              textColor="text100"
              weight="medium"
              :text="$t('modalStatus.header.situation')"
            />
          </th>
          <th>
            <AmTypography
              class="am_status_modal--title"
              textColor="text100"
              weight="medium"
              :text="$t('modalStatus.header.meaning')"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Grupo: Caminho de publicação (fluxo principal) -->
        <tr
          v-for="statusTag in mainFlowTags"
          :key="statusTag.id">
          <td
            :class="['am_status_modal--item am_status_modal--tag', `am_status_modal--item--${statusTag.tag}`]">
            <AmChip
              :text="$t(`modalStatus.tags.${statusTag.tag}.title`)"
              isStatusTag
              :type="statusTag.type"
              :class="[`am_status_modal--item--${statusTag.tag}--tag`]"
            />
          </td>
          <td
            :class="[`am_status_modal--description am_status_modal--item--${statusTag.tag}--description`]">
            <AmTypography
              textColor="text60"
              :text="$t(`modalStatus.tags.${statusTag.tag}.description`)"
            />
          </td>
        </tr>

        <!-- Divisor: estados especiais -->
        <tr class="am_status_modal--divider-row">
          <td
            colspan="2"
            class="am_status_modal--divider-cell">
            <div class="am_status_modal--divider">
              <AmTypography
                class="am_status_modal--divider-label"
                textColor="text40"
                typographyStyle="l8"
                :text="$t('modalStatus.header.specialStates')"
              />
            </div>
          </td>
        </tr>

        <!-- Grupo: Estados especiais (desvios e terminais negativos) -->
        <tr
          v-for="statusTag in specialStateTags"
          :key="statusTag.id">
          <td
            :class="['am_status_modal--item am_status_modal--tag', `am_status_modal--item--${statusTag.tag}`]">
            <AmChip
              :text="$t(`modalStatus.tags.${statusTag.tag}.title`)"
              isStatusTag
              :type="statusTag.type"
              :class="[`am_status_modal--item--${statusTag.tag}--tag`]"
            />
          </td>
          <td
            :class="[`am_status_modal--description am_status_modal--item--${statusTag.tag}--description`]">
            <AmTypography
              textColor="text60"
              :text="$t(`modalStatus.tags.${statusTag.tag}.description`)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { inject } from 'vue';
import { AmChip, AmTypography } from '@appmax_npm/ds-appmax-v3'
import './AmStatusModal.scss'
import { STATUS_MAP } from '@/utils/appStatus'

export default {
  name: 'AmStatusModal',
  components: {
    AmChip,
    AmTypography
  },
  setup() {
    const mq = inject('mq')

    /**
     * Monta a lista de itens do modal a partir do STATUS_MAP, garantindo
     * a ordem correta do fluxo e evitando duplicatas visuais (in-draft e
     * development compartilham a tag 'configuring').
     *
     * Caminho de publicação (fluxo principal):
     *   configuring -> inTest -> inAnalysis -> homolog -> published
     *
     * Estados especiais (desvios e terminais negativos):
     *   adjustmentPending -> reproved -> deactivate
     */
    const MAIN_FLOW_ORDER = [
      'configuring',
      'inTest',
      'inAnalysis',
      'homolog',
      'published'
    ]

    const SPECIAL_STATE_ORDER = [
      'adjustmentPending',
      'reproved',
      'deactivate'
    ]

    function buildTagList(tagOrder) {
      const seen = new Set()
      const result = []

      for (const targetTag of tagOrder) {
        // Encontra a primeira entrada do STATUS_MAP com essa tag
        for (const [, props] of Object.entries(STATUS_MAP)) {
          if (props.tag === targetTag && !seen.has(props.tag)) {
            seen.add(props.tag)
            result.push({ id: result.length + 1, tag: props.tag, type: props.type })
            break
          }
        }
      }

      return result
    }

    const mainFlowTags = buildTagList(MAIN_FLOW_ORDER)
    const specialStateTags = buildTagList(SPECIAL_STATE_ORDER)

    return {
      mq,
      mainFlowTags,
      specialStateTags
    }
  }
}
</script>